import {
  SegmentedControl,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@vnetwork/ui/primitives';
import { Alert } from '@vnetwork/ui/feedback';
import { Field } from '@vnetwork/ui/forms';
import { SSL_MODES, type DomainDraft } from './wizard-types';

/** Step 3 — SSL/TLS mode + minimum TLS version. */
export function StepSsl({
  draft,
  set,
}: {
  draft: DomainDraft;
  set: (patch: Partial<DomainDraft>) => void;
}) {
  const activeHint = SSL_MODES.find((m) => m.value === draft.sslMode)?.hint;
  return (
    <>
      <Field label="Encryption mode" description="How traffic between the edge and your origin is secured.">
        {() => (
          <SegmentedControl
            items={SSL_MODES.map((m) => ({ value: m.value, label: m.label }))}
            value={draft.sslMode}
            onValueChange={(v) => set({ sslMode: v as DomainDraft['sslMode'] })}
            aria-label="SSL mode"
          />
        )}
      </Field>

      {activeHint && <Alert tone="info">{activeHint}</Alert>}

      <Field label="Minimum TLS version" description="TLS 1.3 recommended; 1.2 needed for older clients.">
        {(props) => (
          <Select value={draft.minTls} onValueChange={(v) => set({ minTls: v as DomainDraft['minTls'] })}>
            <SelectTrigger {...props} style={{ maxWidth: 280 }}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="1.2">TLS 1.2</SelectItem>
              <SelectItem value="1.3">TLS 1.3</SelectItem>
            </SelectContent>
          </Select>
        )}
      </Field>
    </>
  );
}
